import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./style.scss";

import LoadingSpinner from "../../elements/loading-spinner";

import useQuery from "../../utils/useQuery";
import { appendQuery } from "../../utils/urlHelper";
import { _3dsStatus } from "../../utils/lynkco-constants";

import { getInstoreOrderStatus, getOrderStatus } from "../../services/orderService";
import { staffInfoSelector } from "../../selectors/application";
import { canUseDOM } from "../../utils";

let watchOrderTimeout;
const PayOrderCallbackRedirect = ({ rendering, fields, lang, history, staffInfo }) => {
  const { successLink, failedLink, successM2MLink } = fields;
  const query = useQuery();
  useEffect(() => {
    const orderId = query.orderId || "";
    const orderNo = query.orderNo || "";
    getOrderPayState(orderNo, orderId);
  }, []);
  const stopWatchOrder = () => {
    if (watchOrderTimeout) {
      clearTimeout(watchOrderTimeout);
    }
  };
  const getOrderPayState = async (orderNo, orderId) => {
    let orderState = null,
      payStatus = "",
      paramError = {
        orderId: orderId,
        orderNo: orderNo
      };
    const queryInStore = canUseDOM() ? query.inStore : "";
    const queryMembership = canUseDOM() ? query.membership : "";
    const queryPdpIsLoan = canUseDOM() ? query.pdpIsLoan : false;
    if (staffInfo || queryInStore) {
      orderState = await getInstoreOrderStatus(orderNo);
    } else {
      orderState = await getOrderStatus(orderNo);
    }
    payStatus = orderState.obj?.paymentTransaction?.status;
    if (queryPdpIsLoan) {
      paramError = {
        lid: orderId,
        lno: orderNo
      };
    }
    if (orderState.code !== "1") {
      let failLinkvalue = appendQuery(failedLink.value.href, {
        code: orderState.code,
        ...paramError
      });
      let defaultRedirectHref = failedLink?.value.href ? failLinkvalue : `/${lang}`;
      stopWatchOrder();
      history.replace(defaultRedirectHref);
    } else if (payStatus === _3dsStatus.pendingHasLink) {
      watchOrderTimeout = setTimeout(getOrderPayState, 5000, orderNo, orderId);
    } else if (payStatus === _3dsStatus.failed || payStatus === _3dsStatus.orderCanceled) {
      let failLinkvalue = appendQuery(failedLink.value.href, {
        code: payStatus,
        ...paramError
      });
      let defaultRedirectHref = failedLink?.value.href ? failLinkvalue : `/${lang}`;
      stopWatchOrder();
      history.replace(defaultRedirectHref);
    } else {
      let successParams = {
        orderId: orderId,
        orderNo: orderNo
      };
      if (queryInStore) {
        Object.assign(successParams, {
          inStore: queryInStore
        });
      }
      if (queryMembership) {
        Object.assign(successParams, {
          membership: queryMembership
        });
      }
      let successLinkValue = appendQuery(successLink.value.href, successParams);
      if (orderState.obj?.riskCheckResult === "Y") {
        successLinkValue = appendQuery(successM2MLink.value.href, successParams);
      }
      stopWatchOrder();
      history.replace(successLinkValue);
    }
  };
  return (
    <div className="payorder-callback-redirect" datasourceid={rendering.dataSource}>
      <LoadingSpinner />
    </div>
  );
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state)
});
export default withRouter(connect(mapStateToProps, null)(PayOrderCallbackRedirect));
